/**
 * Based on a querystring generate the appropriate URL to use
 * inside a href.
 */
export const generateQueryStringURL = (querystring: any): string => {
  return Object.keys(querystring)
    .map((key) => {
      if (Array.isArray(querystring[key])) {
        return querystring[key]
          .map((keyval) => {
            return key + '=' + encodeURIComponent(keyval);
          })
          .join('&');
      }
      return key + '=' + encodeURIComponent(querystring[key]);
    })
    .join('&');
};
